import SelectSearch from "../../../../../Core/Fields/Floating/SelectSearch";


const OperationLeft = ({TMA }) => {
  console.log("asdfghjkjhfdsdfgh",TMA);
  return (
    <div className="row sidebarbox m-0 d-flex flex-column"
      style={{padding: "8px", borderRadius: "5px",minHeight:"300px", maxHeight: "480px",overflowY: "scroll"}}
    >
      
   <div className="col-12 ">
        <div className={TMA.Error ? `mb-3 errorborder` : `mb-3`}>
          <SelectSearch
            list={[]}
            label="Transfer Material Against"
            getOptionLabel={(item) => item.name}
            getOptionValue={(item) => item.name}
            value={TMA.TMA}
            onChange={(val) => TMA.setTMA(val)}
          />
        </div>
      </div>
    </div>
  )
}

export default OperationLeft